import { h } from 'preact';
import { useCallback } from 'preact/hooks';
import { useNewStore, usePlayerContext, useStyles } from '../../../../common/hooks';
import { TEXT_LEVEL_3_FONT_SIZE } from '../../../../common/styles';
import { Delayed, withBreakPoints } from '../../../hoc';
import { LabeledButton } from '../../common';
import {
  SKIP_BTN_LAYER_STYLE,
  SKIP_BTN_STYLE
} from '../../common/buttons/styles';
import { PLAYER_BUTTON_DARK_STYLE, SKIP_BUTTON_ACTIVE, SKIP_BUTTON_CUSTOM_FONT, SKIP_BUTTON_HOVER } from './styles';

function SkipButton({
  show,
  timecode,
  duration,
  isFullscreen,
  trackingEvent,
  tablet,
  label,
  style,
  clickEvent,
  seek = true
}) {
  const player = usePlayerContext();
  const { isTv } = useNewStore('media', player);
  const setStyles = useStyles();

  const btn = useCallback((node) => {
    if (node) setTimeout(() => node.focus(), 100);
  }, []);

  // This is true when timecode is truthy and duration = null
  const shouldHide = (timecode && duration) === true;

  const onSkipButtonShown = () => {
    if (show && !shouldHide && trackingEvent) player.events$.next(trackingEvent);
  };

  return (
    <Delayed onFinish={onSkipButtonShown} isMounted={show && !shouldHide} shouldDelay delay={300}>
      {() => (
        <div
          type="button"
          style={{
            ...setStyles(SKIP_BTN_LAYER_STYLE),
            ...(isFullscreen && tablet && { top: '80%' }),
            animation: show
              ? 'ftv-magneto-skip-button-slide-up .3s'
              : 'ftv-magneto-skip-button-slide-down .3s'
          }}
        >
          <LabeledButton
            finalRef={btn}
            className="ftv-magneto--skip-btn"
            onClick={() => {
              player.trigger(clickEvent);
              player.userEvents$.next(clickEvent);
              if (seek) {
                player.seek(timecode + duration);
              }
            }}
            customStyle={{
              ...setStyles(PLAYER_BUTTON_DARK_STYLE),
              ...setStyles({ ...TEXT_LEVEL_3_FONT_SIZE, ...SKIP_BUTTON_CUSTOM_FONT }),
              ...(isTv ? setStyles(SKIP_BTN_STYLE) : {}),
              ...setStyles(style)
            }}
            customActiveStyle={SKIP_BUTTON_ACTIVE}
            customHoverStyle={SKIP_BUTTON_HOVER}
            label={label}
          />
        </div>
      )}
    </Delayed>
  );
}
export default withBreakPoints(SkipButton);
